
export enum StaffType {
    PDS = 'PDS',
    MEDECIN = 'MEDECIN'
}



export type ChildStepProps = {
  label: string
  checked: boolean
  redirect?: () => void
  showUser?: () => void
}

export type BasicStepProps = {
  icon: React.ReactNode
  childSteps: ChildStepProps[]
  totalNumberOfChildSteps: number
  numberOfCompletedChildSteps: number
}